module.exports = __webpack_public_path__ + "img/full1-min.c136ce03.png";